<template>
  <div>
    <div class="container-fluid featured-page-image">
      <div class="feature-header-page">
        <h1>Our services</h1>
      </div>
    </div>
    <section class="container mt-3">
      <div class="row">
        <div class="col-sm-12 intro mb-3">
          <h2>Dantex PicoJet 330 UK Digital Printer</h2>
          <hr>
          <p>
            Our state-of-the-art Dantex PicoJet 330 UK Digital Printer, Digital Cutter and our experienced in-house team, have the capability to handle high quality print runs of all quantities with fast turnaround to be able to meet the strictest deadlines.
            We also offer a range of finishes, materials, sizes, and shapes using an array of different finishing methods including digital die-cutting.
            Specialist print available upon request.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-sm-12 order-lg-2">
          <img src="@/assets/images/PicoJet_330.jpg" alt="PicoJet 300 Digital Printer" class="w-100"/>
        </div>
        <div class="col-xl-6 col-lg-6 col-sm-12 order-lg-1 services-copy">
          <p>
            Spectrum Digital Labels have recently installed a Dantex PicoJet 330 UV inkjet digital press.
            With a printing speed of 75m/min, the PicoJet 330 is capable of producing more than nine million linear meters of printed labels per year.
          </p>
          <p>
            It is a five colour system which boasts a 2.5 picolitre droplet size and prints at a resolution of 1200 x 1200 dpi on a range of materials from 25 micron film to vinyl, paper and card.
          </p>
        </div>
      </div>
        <div class="row boxes">
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="box ">
              <img class="box-image" src="@/assets/images/Anglian-Chem-3.jpg" alt="PicoJet 300 Printing Process" />
            </div>
          </div>

          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="box ">
              <img class="box-image" src="@/assets/images/Anglian-Chem-5.jpg" alt="PicoJet 300 Printing Process" />
            </div>
          </div>

          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="box ">
              <img class="box-image" src="@/assets/images/Anglian-Chem-6.jpg" alt="PicoJet 300 Printing Process" />
            </div>
          </div>
        </div>
    </section>

    <section class="container">
      <div class="row mb-5">
        <div class="col-12 col-lg-6 intro">
          <h2 class="mt-0">Digicon Lite 3</h2>
          <hr>
          <p>
            The Digicon Lite 3 is a compact digital finishing system built to the same exacting standards as the larger, market-leading Digicon Series 3.
          </p>

          <div class="services-copy">
            <ul class="mb-0">
              <li>Capable of running at 64 metres per minute in semi-rotary.</li>
              <li>Boasting a tolerance of .1 of a mm when cutting out.</li>
              <li>Also able to do cold foiling and laminating in line.</li>
            </ul>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <img src="@/assets/images/DigiLite_3.jpg" alt="Digicon Lite 3 Digital Printer" class="w-100"/>
        </div>
      </div>
    </section>

    <action-panel></action-panel>
  </div>
</template>

<script>
import ActionPanel from '../partials/ActionPanel'
export default {
  name: 'Services',
  components: {ActionPanel}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Services.vue